
export function getPlaylist( endcard, limit, postId ) {
    const endpoint = '/wp-json/fsd/v1/wp/mpx-related-videos';
    return fetch( `${endpoint}?mpxfeed=${encodeURIComponent(endcard)}&limit=${limit}&postId=${postId}`)
        .then((resp) => resp.json());
}

export function getPlayerConfig( uri ) {
    let endpoint = uri; 
    if(!isValidUrl(uri)) {
        endpoint = `/wp-json/v1/player-config/${uri}`;
    }
    let headers = {};
    if (window.fsSettings && window.fsSettings.dpp) {
      headers = {
        'x-api-key': fsSettings.dpp.apiKey
      }
    }
    return fetch(endpoint, { headers }).then((res) => res.json());
}

const isValidUrl = (str) => {
  try {
    // eslint-disable-next-line no-new
    new URL(str);
    return true;
  } catch (_) {
    return false;
  }
};